import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CustomSelect } from '../dropDown/Dropdown';
import i18n from '@/lib/i18n/i18n';
import { changeAppLanguage } from '@/lib/i18n/documentLocale';
import SaudiArabiaFlag from '../icons/flags/SaudiArabiaFlag';
import UnitedStatesFlag from '../icons/flags/UnitedStatesFlag';

export default function LanguageSelectButton() {
    const navigate = useNavigate();
    const location = useLocation();
    const [value, setValue] = useState<string>(i18n.language?.split('-')[0] || 'ar');

    return (
        <CustomSelect
            value={value}
            onValueChange={(newLocale) => {
                setValue(newLocale);
                void changeAppLanguage(newLocale);
                // Navigate to same path with new locale (e.g. /ar/services -> /en/services)
                const pathParts = location.pathname.split('/').filter(Boolean);
                if (pathParts[0] === 'ar' || pathParts[0] === 'en') {
                    pathParts[0] = newLocale;
                    navigate(`/${pathParts.join('/')}${location.search}${location.hash}`);
                } else {
                    navigate(`/${newLocale}${location.pathname}${location.search}${location.hash}`);
                }
            }}
            width="w-8"
            height="h-8"
            className="!p-0 mx-auto"
            options={[
                { value: 'ar', icon: <SaudiArabiaFlag /> },
                { value: 'en', icon: <UnitedStatesFlag /> },
            ]}
        />
    );
}
